import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsScreensAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-screens-associate',
	path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa',
};
